import * as i0 from '@angular/core';
import { NgModule } from '@angular/core';
import * as i1 from '@nebular/theme';
import { NbSvgIcon } from '@nebular/theme';
import { icons } from 'eva-icons';

/*
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
class NbEvaSvgIcon extends NbSvgIcon {
  constructor(name, content) {
    super(name, '');
    this.name = name;
    this.content = content;
  }
  getContent(options) {
    return this.content.toSvg({
      width: '100%',
      height: '100%',
      fill: 'currentColor',
      ...options
    });
  }
}
class NbEvaIconsModule {
  constructor(iconLibrary) {
    this.NAME = 'eva';
    iconLibrary.registerSvgPack(this.NAME, this.createIcons());
    iconLibrary.setDefaultPack(this.NAME);
  }
  createIcons() {
    return Object.entries(icons).map(([name, icon]) => {
      return [name, new NbEvaSvgIcon(name, icon)];
    }).reduce((newIcons, [name, icon]) => {
      newIcons[name] = icon;
      return newIcons;
    }, {});
  }
  static {
    this.ɵfac = function NbEvaIconsModule_Factory(t) {
      return new (t || NbEvaIconsModule)(i0.ɵɵinject(i1.NbIconLibraries));
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NbEvaIconsModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NbEvaIconsModule, [{
    type: NgModule,
    args: [{}]
  }], () => [{
    type: i1.NbIconLibraries
  }], null);
})();

/*
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NbEvaIconsModule, NbEvaSvgIcon };
